/** CRA inlines at build time. Only the literal string `true` (any case) opens checkout. */
export function isStoreOpen(): boolean {
  return String(process.env.REACT_APP_OPEN_STORE ?? "").trim().toLowerCase() === "true";
}
